export default {
  ['panorama']: require('./panorama/Page').default
}
